import * as React from 'react';

import { SECURITY_EVENT_STATUSES } from 'security-app/hooks/api/securityEventsAPI.types';

// eslint-disable-next-line react/jsx-no-useless-fragment
const Status = ({ statusId }: { statusId: string }) => <>{SECURITY_EVENT_STATUSES[statusId]}</>;

export default Status;
